import { ipsos, supuesto } from ".";

// Lámina 64 (supermercados, base 400/338) y lámina 66 (conveniencia, base 400).
const P_COMPRA_SUPER = "¿Hace compras en supermercados?";
const P_FRECUENCIA_SUPER = "¿Con qué frecuencia compra en supermercados?";
const P_MARCA_SUPER = "¿Cuál es su supermercado preferido?";
const P_MOTIVO_SUPER = "¿Por qué prefiere ese supermercado?";
const P_USA_CONV = "¿Usa tiendas de conveniencia?";
const P_FRECUENCIA_CONV = "¿Con qué frecuencia usa tiendas de conveniencia?";
const P_MARCA_CONV = "¿Cuál es su tienda de conveniencia preferida?";

export const IPSOS_SUPER = {
  penetracion: ipsos(0.851, { lamina: 64, pregunta: P_COMPRA_SUPER, base: 400 }),
  noPenetracion: ipsos(0.149, { lamina: 64, pregunta: P_COMPRA_SUPER, base: 400 }),

  // factor = visitas/mes (supuesto), ticket = ticket promedio por frecuencia (supuesto, CLP)
  frecuenciaCompra: {
    diario: {
      pct: ipsos(0.026, { lamina: 64, pregunta: P_FRECUENCIA_SUPER, base: 338 }),
      factor: supuesto(30, { nota: "visitas/mes" }),
      ticket: supuesto(12500, { nota: "ticket promedio de la compra diaria" }),
    },
    variasSemana: {
      pct: ipsos(0.199, { lamina: 64, pregunta: P_FRECUENCIA_SUPER, base: 338 }),
      factor: supuesto(12, { nota: "visitas/mes" }),
      ticket: supuesto(37500, { nota: "ticket promedio de la compra mediana" }),
    },
    semanal: {
      pct: ipsos(0.356, { lamina: 64, pregunta: P_FRECUENCIA_SUPER, base: 338 }),
      factor: supuesto(4, { nota: "visitas/mes" }),
      ticket: supuesto(54000, { nota: "ticket promedio de la compra semanal" }),
    },
    quincenal: {
      pct: ipsos(0.211, { lamina: 64, pregunta: P_FRECUENCIA_SUPER, base: 338 }),
      factor: supuesto(2, { nota: "visitas/mes" }),
      ticket: supuesto(187500, { nota: "ticket promedio de la compra quincenal" }),
    },
    mensual: {
      pct: ipsos(0.208, { lamina: 64, pregunta: P_FRECUENCIA_SUPER, base: 338 }),
      factor: supuesto(0.75, { nota: "visitas/mes" }),
      ticket: supuesto(375000, { nota: "ticket promedio de la compra mensual" }),
    },
  },

  marketShare: {
    Líder: ipsos(0.453, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
    Jumbo: ipsos(0.278, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
    Unimarc: ipsos(0.119, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
    "Santa Isabel": ipsos(0.082, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
    Tottus: ipsos(0.05, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
    Otros: ipsos(0.018, { lamina: 64, pregunta: P_MARCA_SUPER, base: 338 }),
  },

  // No se usa programáticamente hoy (el disclaimer imprime estos % como texto literal)
  motivosPreferencia: {
    cercania: ipsos(0.484, { lamina: 64, pregunta: P_MOTIVO_SUPER, base: 338, nota: "multirespuesta" }),
    ofertas: ipsos(0.395, { lamina: 64, pregunta: P_MOTIVO_SUPER, base: 338, nota: "multirespuesta" }),
    preciosBajos: ipsos(0.38, { lamina: 64, pregunta: P_MOTIVO_SUPER, base: 338, nota: "multirespuesta" }),
    variedad: ipsos(0.267, { lamina: 64, pregunta: P_MOTIVO_SUPER, base: 338, nota: "multirespuesta" }),
  },
};

export const IPSOS_CONVENIENCIA = {
  penetracion: ipsos(0.857, { lamina: 66, pregunta: P_USA_CONV, base: 400 }),
  noPenetracion: ipsos(0.143, { lamina: 66, pregunta: P_USA_CONV, base: 400 }),

  // factor = visitas/mes (supuesto comercial derivado de la etiqueta de frecuencia Ipsos)
  frecuenciaUso: {
    diario: {
      pct: ipsos(0.182, { lamina: 66, pregunta: P_FRECUENCIA_CONV, base: 400 }),
      factor: supuesto(30, { nota: "visitas/mes" }),
    },
    variasSemana: {
      pct: ipsos(0.45, { lamina: 66, pregunta: P_FRECUENCIA_CONV, base: 400 }),
      factor: supuesto(12, { nota: "visitas/mes" }),
    },
    semanal: {
      pct: ipsos(0.246, { lamina: 66, pregunta: P_FRECUENCIA_CONV, base: 400 }),
      factor: supuesto(4, { nota: "visitas/mes" }),
    },
    quincenal: {
      pct: ipsos(0.068, { lamina: 66, pregunta: P_FRECUENCIA_CONV, base: 400 }),
      factor: supuesto(2, { nota: "visitas/mes" }),
    },
    mensual: {
      pct: ipsos(0.054, { lamina: 66, pregunta: P_FRECUENCIA_CONV, base: 400 }),
      factor: supuesto(0.75, { nota: "visitas/mes" }),
    },
  },

  ticketPromedio: supuesto(8000, { nota: "ticket promedio de compra en conveniencia" }),

  // Menciones multirespuesta de lámina 66 normalizadas a 100 (Oxxo 65,2 de 193,6 = 33,7)
  marketShare: {
    Oxxo: ipsos(0.337, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    Castaño: ipsos(0.222, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    "OK Market": ipsos(0.112, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    Pronto: ipsos(0.098, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    "Upa!": ipsos(0.087, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    Upita: ipsos(0.056, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    Spid: ipsos(0.038, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
    Otros: ipsos(0.05, { lamina: 66, pregunta: P_MARCA_CONV, base: 400, nota: "normalizado de multirespuesta" }),
  },
};

export const ESCENARIOS_CAPTACION_RETAIL = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];

export const INVERSION_REFERENCIA_3M_RETAIL = supuesto(6000000, { nota: "inversión de referencia a 3 meses" });
